import { useConsultation } from '@entities/consultations';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import parseISO from 'date-fns/parseISO';

import { xhr } from '@shared/config';

import { useCertificateMessage } from '@src/library/hooks/common';

export const useBuyConsultation = (consultationId: number) => {
	const { consultation } = useConsultation(consultationId);
	const { onRedirect } = useCertificateMessage();

	const onBuy = async () => {
		if (!consultation) return;

		try {
			const data = {
				start_time: consultation.start_time,
				consultation_type: consultation.type,
				coach: consultation.coach.id,
				duration: differenceInMinutes(
					parseISO(consultation.end_time),
					parseISO(consultation.start_time)
				),
			};

			const res = await xhr.post(`/api/v1/schedules/schedule/buy/`, data);

			if (res.data.redirect_url) {
				return res.data.redirect_url;
			}
		} catch (error) {
			console.log(error);
		}
	};

	return {
		onBuy: () => onRedirect(onBuy),
	};
};
